<template>
  <el-card>
    <el-form label-width="7rem">
      <el-row type="flex" :gutter="16" :style="{ flexWrap: 'wrap' }">
        <el-col :sm="12">
          <el-form-item label="เลขที่ตั๋วขายฝาก">
            <el-input
              v-model="data.ticketNo"
              @input="emit('ticketNo', $event)"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="16" :style="{ flexWrap: 'wrap' }">
        <el-col :sm="12">
          <el-form-item label="วันที่รับขายฝาก">
            <el-date-picker
              v-model="data.date"
              :style="{ width: '100%' }"
              @input="emitDate($event)"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="วันที่ครบกำหนด">
            <el-date-picker
              v-model="data.dueDate"
              :picker-options="dueDatePickerOptions"
              :style="{ width: '100%' }"
              @input="emit('dueDate', $event)"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="16" :style="{ flexWrap: 'wrap' }">
        <el-col :sm="12">
          <el-form-item label="อัตราดอกเบี้ย">
            <el-select
              v-model="data.interest"
              :style="{ width: '100%' }"
              @change="emitInterest"
            >
              <el-option
                v-for="(item, index) in interestOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="ดอกเบี้ย/เดือน">
            <number-input
              v-model="data.interestPerMonth"
              @input="emit('interestPerMonth', $event)"
            >
              <template slot="append">บาท</template>
            </number-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
import { PawnService } from '@/services'
// Components
import { NumberInput } from '@/components/form/number-input'

export default {
  components: { NumberInput },

  props: {
    data: {
      type: Object,
      default: () => ({
        ticketNo: '',
        date: null,
        dueDate: null,
        interest: null,
        interestPerMonth: null
      })
    }
  },

  data() {
    return {
      interestOptions: [],
      dueDatePickerOptions: {
        disabledDate: time => time.getTime() < this.data.date
      }
    }
  },

  created() {
    this.fetchInterestRates()
  },

  methods: {
    async fetchInterestRates() {
      const {
        data: { result }
      } = await PawnService.getInterestRates()

      this.interestOptions = result.map(item => ({
        value: +item.value / 100,
        label: item.value + '%'
      }))
    },

    emit(key, value) {
      const data = { ...this.data, [key]: value }
      this.$emit('update:data', data)
    },

    emitDate(value) {
      this.emit('date', value)

      const dueDate = this.data.dueDate

      if (value > dueDate) {
        this.emit('dueDate', value)
      }
    },

    async emitInterest(value) {
      await this.emit('interest', value)
      this.$emit('interestRateChange')
    }
  }
}
</script>
